module.exports = __webpack_public_path__ + "01_veryshort_grey.2bf56404.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_veryshort_grey.png
// module id = 6o0l
// module chunks = 0